import { Component } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Tooltip, OverlayTrigger } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import styled from 'styled-components'

const Button = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  margin-right: 10px;

  .fa {
    vertical-align: middle;
    font-size: 14px;
  }

  &:focus {
    outline: none;
  }
`

class CopyUrl extends Component {
  state = { tooltip: 'Copy url to clipboard' }

  url = window.location.href

  onCopy = () => {
    this.setState({ tooltip: 'Copied!' })
  }

  render() {
    const tooltip = <Tooltip id="cu-tooltip">{this.state.tooltip}</Tooltip>

    return (
      <OverlayTrigger placement="top" overlay={tooltip} shouldUpdatePosition>
        <CopyToClipboard text={this.url} onCopy={this.onCopy}>
          <Button>
            <FontAwesome name="clipboard" />
          </Button>
        </CopyToClipboard>
      </OverlayTrigger>
    )
  }
}

export default CopyUrl
